import { Paragraph } from '@alto-avios/alto-ui';

import { Popover } from '../../Popover';
import { Button } from '../../Button';
import { pushGTMEvent } from '../../../utilities';
import { MegaNavData } from '../../services/content';

import { MegaNavSection } from './MegaNavSection/MegaNavSection';
import styles from './MegaNav.module.scss';

export interface MegaNavProps {
  nav: MegaNavData;
}

export const MegaNav = ({ nav: { footerText, label, sections, link } }: MegaNavProps) => (
  <Popover
    closeDelay={500}
    openDelay={500}
    trigger={
      <Button emphasis="quaternary" styleVariant="neutral" onPress={() => pushGTMEvent(label, label, '1')}>
        {label}
      </Button>
    }
    placement="bottom"
    aria-label={label}
    isNonModal
  >
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        {sections.map((section) => (
          <MegaNavSection
            key={section.header}
            data={section}
            onLinkPress={(section, link, position) => pushGTMEvent(`supernav - ${label}`, `${section.header} | ${position + 1} | ${link.label}`, '2')}
          />
        ))}
      </div>
      {link && (
        <div className={styles.footer}>
          <Paragraph size="sm">{footerText}</Paragraph>
          <Button
            emphasis="quaternary"
            href={link.href}
            iconEndProps={{ iconName: 'arrow-right', iconSize: 'sm' }}
            onPress={() => pushGTMEvent(`supernav - ${label}`, 'learn more')}
            size="sm"
          >
            {link.text}
          </Button>
        </div>
      )}
    </div>
  </Popover>
);
